import gql from 'graphql-tag'

export const SUBMIT_PUBLIC_FORM = gql`
	mutation publicFormSubmit($publicFormCode: String!, $submitterEmail: String) {
		publicForm_Submit(publicFormCode: $publicFormCode, submitterEmail: $submitterEmail) {
			success
		}
	}
`
